/* PAE · Galería de producto: deslizar sin bloquear el scroll y ampliar fotos o videos */
(function () {
  if (window.BGPGallery) return;
  window.BGPGallery = true;

  function init(gal) {
    if (gal.dataset.bgpLbReady) return;
    gal.dataset.bgpLbReady = '1';
    var stage = gal.querySelector('[data-bgp-stage]');
    if (!stage) return;
    var slides = Array.prototype.slice.call(stage.children);
    var lb = document.querySelector('[data-bgp-lb="' + gal.getAttribute('data-bgp-gallery') + '"]');

    function current() { return Math.round(stage.scrollLeft / Math.max(1, stage.clientWidth)); }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      stage.scrollTo({ left: stage.clientWidth * i, behavior: 'smooth' });
    }

    /* Deslizar: solo el movimiento horizontal cambia de foto; el vertical lo maneja el navegador (scroll normal). */
    var sx = 0, sy = 0, tracking = false, moved = false;
    stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      tracking = true; moved = false; sx = e.clientX; sy = e.clientY;
    });
    stage.addEventListener('pointercancel', function () { tracking = false; moved = true; });
    stage.addEventListener('pointerup', function (e) {
      if (!tracking) return;
      tracking = false;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (Math.abs(dx) > 10 || Math.abs(dy) > 10) moved = true;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) go(current() + (dx < 0 ? 1 : -1));
    });
    /* Abrir con el clic (no con pointerup) evita que el mismo toque cierre el modal al aparecer. */
    stage.addEventListener('click', function () {
      if (moved) { moved = false; return; }
      open(current());
    });
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(current()); }
    });

    if (!lb) return;
    var box = lb.querySelector('[data-bgp-lb-stage]');
    var count = lb.querySelector('[data-bgp-lb-count]');
    var prev = lb.querySelector('[data-bgp-lb-prev]');
    var next = lb.querySelector('[data-bgp-lb-next]');
    var closeBtn = lb.querySelector('[data-bgp-lb-close]');
    var idx = 0, lastFocus = null;

    function render() {
      var s = slides[idx];
      box.innerHTML = '';
      if (!s) return;
      var tpl = s.querySelector('template[data-bgp-video]');
      if (tpl) {
        box.appendChild(tpl.content.cloneNode(true));
        var v = box.querySelector('video');
        if (v) {
          v.setAttribute('playsinline', '');
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        }
      } else if (s.getAttribute('data-bgp-full')) {
        var img = new Image();
        img.src = s.getAttribute('data-bgp-full');
        img.alt = s.getAttribute('data-bgp-alt') || '';
        box.appendChild(img);
      } else {
        var src = s.querySelector('img');
        if (src) box.appendChild(src.cloneNode(true));
      }
      if (count) count.textContent = slides.length > 1 ? (idx + 1) + ' / ' + slides.length : '';
      if (prev) prev.hidden = slides.length < 2;
      if (next) next.hidden = slides.length < 2;
    }
    function open(i) {
      idx = i;
      lastFocus = document.activeElement;
      render();
      lb.hidden = false;
      document.documentElement.classList.add('bgp-lb-open');
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      box.innerHTML = '';
      lb.hidden = true;
      document.documentElement.classList.remove('bgp-lb-open');
      go(idx);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    function step(d) { idx = (idx + d + slides.length) % slides.length; render(); }

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target === box) close(); });
    lb.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') step(1);
      else if (e.key === 'ArrowLeft') step(-1);
    });
    var lx = 0, ly = 0;
    box.addEventListener('pointerdown', function (e) { lx = e.clientX; ly = e.clientY; });
    box.addEventListener('pointerup', function (e) {
      var dx = e.clientX - lx, dy = e.clientY - ly;
      if (slides.length > 1 && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) step(dx < 0 ? 1 : -1);
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-bgp-gallery]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();